import { TFunc } from '@Translations/types';
import * as yup from 'yup';

export const nameSchema = (t: TFunc) =>
	yup.string().required(t('Name is required'));

export const sensorTypeSchema = (t: TFunc) =>
	yup
		.string()
		.min(1, t('Sensor type is required'))
		.required(t('Sensor type is required'))
		.typeError(t('Sensor type is required'));

const sensorShape = yup.string();
export const sensorsSchema = (t: TFunc) =>
	yup
		.array()
		.of(sensorShape)
		.min(1, t('At least one sensor is required'))
		.required(t('Sensors are required'));

const sensorGroupShape = (t: TFunc) => ({
	name: nameSchema(t),
	sensorType: sensorTypeSchema(t),
	sensors: sensorsSchema(t),
});

export const sensorGroupSchema = (t: TFunc) => yup.object(sensorGroupShape(t));
